import React, { FunctionComponent } from "react";

import { DVInlineOperator } from "./DVIInlineOperator";
import { DVInlineCategory } from "./DVInlineCategory";
import { DVInlineLine } from "./DVInlineLine";
import { DVInlineNumber } from "./DVInlineNumber/DVInlineNumber";
import { DVInlinePoint } from "./DVInlinePoint";
import { DVInlineStaticSubCategory } from "./DVInlineStaticSubCategory";
import { DVInlineSubCategory } from "./DVInlineSubCategory";
import { DVInlineTakeoffVariable } from "./DVInlineTakeoffVariable";
import { DVInlineText } from "./DVinlineText";
import { DVInlineProps } from "./types";

export const DynamicVariableInline: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
  ...props
}) => {
  switch (dynamicVariable.variableType) {
    case "TAKEOFF_VARIABLE":
      return (
        <DVInlineTakeoffVariable {...props} dynamicVariable={dynamicVariable} />
      );
    case "NUMBER":
      return <DVInlineNumber {...props} dynamicVariable={dynamicVariable} />;
    case "OPERATOR":
      return <DVInlineOperator {...props} dynamicVariable={dynamicVariable} />;
    case "CATEGORY":
    case "PARENT_CATEGORY":
      return <DVInlineCategory {...props} dynamicVariable={dynamicVariable} />;
    case "SUBCATEGORY":
    case "PARENT_SUBCATEGORY":
      return (
        <DVInlineSubCategory {...props} dynamicVariable={dynamicVariable} />
      );
    case "PARENT_STATIC_SUBCATEGORY":
    case "STATIC_SUBCATEGORY":
      return (
        <DVInlineStaticSubCategory
          {...props}
          dynamicVariable={dynamicVariable}
        />
      );
    case "LINE":
      return <DVInlineLine {...props} dynamicVariable={dynamicVariable} />;
    case "POINT":
      return <DVInlinePoint {...props} dynamicVariable={dynamicVariable} />;
    case "TEXT":
      return <DVInlineText {...props} dynamicVariable={dynamicVariable} />;
    default:
      return <></>;
  }
};
